export default class SearchForm {
  static init() {
    this.events()
  }

  static events() {
    const btnSearch = document.getElementById('btnSearch')
    const btnSearchClose = document.getElementById('btnSearchClose')
    const inputSearch = document.getElementById('inputSearch')

    btnSearch.addEventListener('click', () => {
      document.body.classList.add('search-popup-active')
      setTimeout(() => {
        inputSearch.focus()
      }, 300)
    })

    btnSearchClose.addEventListener('click', () => {
      document.body.classList.remove('search-popup-active')
    })
  }
}
